import {
    fetchBasicUrlPostJson,
    fetchBasicJsonPostJson,
    fetchBasicGetJson,
    fetchBasicJsonPost
} from '@/script/common';

export default {
    getGridData: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            ...filter
        };
        return fetchBasicUrlPostJson('/Research/ResearchGrid', {
            asGridData: true,
            data: parameters,
            signal
        });
    },
    getMyResearchVisits: (signal) => {
        return fetchBasicGetJson('/Research/MyResearchVisits', {
            signal
        });
    },
    addVisit: (ResearchCode) => {
        return fetchBasicJsonPost('/Research/AddVisit', {
            data: { ResearchCode }
        });
    },
    getData: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            ...filter
        };
        return fetchBasicJsonPostJson('/Research/GetData', {
            data: parameters,
            signal
        });
    },
};



